import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { generateDailyWorkout } from "../services/workoutGenerator"; // Import your generator

export default function PaymentSuccess() {
  const [status, setStatus] = useState("Verifying payment...");
  const navigate = useNavigate();

  useEffect(() => {
    const cookTheMeal = async () => {
      // 1. Retrieve the "Order" from the browser pocket
      const programId = localStorage.getItem("pending_program_id");
      const userId = localStorage.getItem("pending_user_id");

      if (!programId || !userId) {
        setStatus("No pending order found.");
        return;
      }

      setStatus("Payment successful! Generating your workout now...");

      try {
        // 2. Call the AI Generator directly from the browser
        await generateDailyWorkout({
          userId: userId,
          programId: programId, // We use the ID we saved
          supabase: supabase,
          setLoading: () => {}, // Dummy function
          setStatusMessage: setStatus,
        });

        // 3. Clean up and Finish
        localStorage.removeItem("pending_program_id");
        setStatus("Done! Redirecting to dashboard...");
        setTimeout(() => navigate("/skills-workouts"), 2000);

      } catch (error) {
        console.error(error);
        setStatus("Error generating workout. Please contact support.");
      }
    };

    cookTheMeal();
  }, [navigate]);

  return (
    <div className="p-10 text-center">
      <h1 className="text-2xl font-bold mb-4">Processing Order</h1>
      <p>{status}</p>
      {/* Optional: Add a loading spinner here */}
      <div className="mt-4 animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
}